import { Component } from '@angular/core';

import { Angulartics2AppInsights } from 'angulartics2/appinsights';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import smoothscroll from 'smoothscroll-polyfill';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {
    constructor(
        angulartics2AppInsights: Angulartics2AppInsights,
        angulartics2GoogleTagManager: Angulartics2GoogleTagManager) {
        angulartics2GoogleTagManager.startTracking();
        smoothscroll.polyfill();
    }
}
